import { Button, Grid, MenuItem, Typography } from "@mui/material";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import {
  LATE_CANCELLATION_TYPES,
  VARIABLE_RATE_TYPES,
} from "../../ratecard/RateCardConstants";
import CiDiscountPremium from "./ClientInvoiceDiscountPremium";
import { mapSnakeCaseToCapitalCaseWithSpaces } from "../../../../components/common/utils/StringUtils";
import {
  EditClientInvoiceRouteRateUIRequest,
  EditClientInvoiceUIRequest,
} from "../ClientInvoiceInterfaces";
import CiFuelSurcharge from "./ClientInvoiceFuelSurcharge";
import CiPeakSurcharge from "./ClientInvoicePeakSurcharge";
import DatePicker from "react-multi-date-picker";
import {
  ClientInvoiceEditDetailResponse,
  RouteResponse,
} from "../../../../app/models/responseModels/ClientInvoiceResponses";
import { isDisabledFieldDueToDateRangeEdits } from "../utils/RatecardUtils";
import { FieldValueEditList } from "./FieldValueEditList";
import { SimpleFieldDatePicker } from "./SimpleFieldDatePicker";
import { RatecardResponse } from "../../ratecard/dtos/RateCardResponse";
import { SimpleValueDateRangeType } from "../../../../app/models/requestModels/ClientInvoiceEditRequest";
import { FormikTouched } from "formik";
import InfoWithTooltip from "../InfoWithToolTip";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/features/store/store";
import CiCustomFields from "./ClientInvoiceCustomFields";

interface Props {
  originalRatecardData: RatecardResponse | undefined;
  values: EditClientInvoiceRouteRateUIRequest;
  touched: FormikTouched<EditClientInvoiceUIRequest>;
  route: RouteResponse | null;
  store: string;
  invoiceStartDate: Date;
  invoiceEndDate: Date;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
  editData: ClientInvoiceEditDetailResponse | null;
}

const EditRateCard = ({
  values,
  touched,
  route,
  store,
  invoiceStartDate,
  invoiceEndDate,
  handleChange,
  handleBlur,
  setFieldValue,
  originalRatecardData,
  editData,
}: Props) => {
  const getUsedDateRanges = (dateRangesValues: SimpleValueDateRangeType[]) => {
    return dateRangesValues.map((item) => {
      // item.date_range.map((dateObject) => dateObject.toDate())

      let startDate = item.startDate;
      let endDate = item.endDate;

      console.log("Start Date", startDate);
      console.log("End Date", endDate);

      // this if is used for special case where we fetch date range edits and get them as string
      // as that created a type issue so I converted that to Date object right here
      if (typeof startDate === "string") startDate = new Date(startDate);
      if (typeof endDate === "string") endDate = new Date(endDate);
      return [startDate, endDate];
    });
  };
  const { isLoading, storesForCurrentClientInvoice } = useSelector(
    (state: RootState) => state.clientInvoice
  );
  const [tooltipText2, setTooltipText2] = useState<string>("");
  const [tooltipText3, setTooltipText3] = useState<string>("");
  const [tooltipText1, setTooltipText1] = useState<string>("");
  const [tooltipText4, setTooltipText4] = useState<string>("");

  const getWarningText = (
    primaryDateRange: { startDate: any; endDate: any },
    dateRangeValues: SimpleValueDateRangeType[]
  ): string => {
    const userStartDate = new Date(primaryDateRange?.startDate); // Get user-selected start date
    const userEndDate = new Date(primaryDateRange?.endDate); // Get user-selected end date

    // Function to check if the user-selected dates lie within the existing date range
    const isDateRangeColliding = (
      existingStart: Date,
      existingEnd: Date
    ): boolean => {
      return (
        (userStartDate >= existingStart && userStartDate <= existingEnd) || // User start date within the existing range
        (userEndDate >= existingStart && userEndDate <= existingEnd) || // User end date within the existing range
        (userStartDate <= existingStart && userEndDate >= existingEnd) // User range completely covers the existing range
      );
    };
    // Check for collisions with all existing ranges
    const conflictingStoreNames = dateRangeValues.reduce(
      (acc, existingRange) => {
        const existingStartDate = new Date(existingRange.startDate);
        const existingEndDate = new Date(existingRange.endDate);

        // Check for collision and add store name if applicable
        if (isDateRangeColliding(existingStartDate, existingEndDate)) {
          const existingStoreIds = existingRange?.storeIds;
          const conflictingStores = store
            ?.split(",")
            .map(Number)
            .filter((storeId) => existingStoreIds?.includes(storeId))
            .map(
              (storeId) =>
                storesForCurrentClientInvoice.find(
                  (store) => store.id === storeId
                )?.storeId
            )
            .filter(Boolean) as string[];

          acc.push(...conflictingStores); // Add conflicting store names to accumulator
        }

        return acc;
      },
      [] as string[] // Initial empty array for accumulating conflicting store names
    );
    const warnings =
      conflictingStoreNames.length > 0
        ? `This date range edit will not work for the stores mentioned below as they have conflicting date ranges:\n\n${conflictingStoreNames
            .map((storeName) => `- ${storeName}`)
            .join("\n")}`
        : "";

    return warnings;
  };

  console.log("Inside the Edit Rate Card ");

  useEffect(() => {
    setTooltipText1(
      getWarningText(
        {
          startDate: values?.master_date_range?.length
            ? values?.master_date_range?.[0]
            : values?.base_rate_date_range[0]?.toDate(),
          endDate: values?.master_date_range?.length
            ? values?.master_date_range?.[1]
            : values?.base_rate_date_range[1]?.toDate(),
        },
        values?.base_rate_date_range_values || []
      )
    );
  }, [values?.base_rate_date_range, values?.master_date_range]);

  useEffect(() => {
    setTooltipText2(
      getWarningText(
        {
          startDate: values?.master_date_range?.length
            ? values.master_date_range[0]
            : values?.variable_rate_date_range[0]?.toDate(),
          endDate: values?.master_date_range?.length
            ? values.master_date_range[1]
            : values?.variable_rate_date_range[1]?.toDate(),
        },
        values?.variable_rate_date_range_values || []
      )
    );
  }, [values?.variable_rate_date_range, values?.master_date_range]);

  useEffect(() => {
    setTooltipText3(
      getWarningText(
        {
          startDate: values?.master_date_range?.length
            ? values.master_date_range[0]
            : values?.route_minimum_date_range[0]?.toDate(),
          endDate: values?.master_date_range?.length
            ? values.master_date_range[1]
            : values?.route_minimum_date_range[1]?.toDate(),
        },
        values?.route_minimum_date_range_values || []
      )
    );
  }, [values?.route_minimum_date_range, values?.master_date_range]);

  useEffect(() => {
    setTooltipText4(
      getWarningText(
        {
          startDate: values?.master_date_range?.length
            ? values.master_date_range[0]
            : values?.late_cancellation_date_range[0]?.toDate(),
          endDate: values?.master_date_range?.length
            ? values.master_date_range[1]
            : values?.late_cancellation_date_range[1]?.toDate(),
        },
        values?.late_cancellation_date_range_values || []
      )
    );
  }, [values?.late_cancellation_date_range, values?.master_date_range]);

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <Grid item xs={6} display={route === null ? "" : "none"}>
        <DatePicker
          id={`master_date_range`}
          name={`master_date_range`}
          format="MM/DD/YYYY"
          className="green"
          dateSeparator=" ~ "
          range
          placeholder="Master Date Range"
          rangeHover
          style={{ height: "36px", marginTop: "8px" }}
          minDate={invoiceStartDate}
          maxDate={invoiceEndDate}
          value={values.master_date_range}
          onChange={(range) => {
            const safeDates = range?.map((d) =>
              typeof d?.toDate === "function" ? d.toDate() : null
            );
            setFieldValue("master_date_range", safeDates);
          }}
        />
        <Button
          variant="text"
          onClick={() => {
            setFieldValue(`master_date_range`, []);
          }}
        >
          Clear
        </Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container alignItems={"center"} columnSpacing={1}>
          <Grid item xs={5}>
            <Typography>Base Rate</Typography>
          </Grid>
          <Grid item xs={1}>
            <InfoWithTooltip
              tooltipText={tooltipText1}
              isDisabled={tooltipText1 === "" ? true : false}
              sx={{ color: "orange" }} // Set icon color to orange
            />
          </Grid>
          <Grid container xs={6} alignItems={"center"} columnSpacing={1}>
            <Grid item xs={route === null ? 6 : 12}>
              <FormikTextField
                margin="normal"
                id="baseRate"
                name="baseRate"
                label=""
                size="small"
                // sx={{ background: "aliceblue" }}
                helperText={
                  route !== null &&
                  values.baseRate !==
                    originalRatecardData?.ratecardValues.baseRate
                    ? `Original value : ${originalRatecardData?.ratecardValues.baseRate}`
                    : ""
                }
                isDisabled={
                  values.master_date_range &&
                  values.master_date_range.length === 2 &&
                  store?.split(",").map(Number).length === 1
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(values.base_rate_date_range_values)
                      )
                    : false
                }
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                fullWidth
                variant={"outlined"}
                required
              />
            </Grid>

            {route === null ? (
              <SimpleFieldDatePicker
                values={values}
                text={tooltipText1}
                field={values.baseRate}
                date_range={values.base_rate_date_range}
                date_range_values={values.base_rate_date_range_values}
                fieldName={`baseRate`}
                fieldDateRangeName={`base_rate_date_range`}
                fieldDateRangeValuesName={`base_rate_date_range_values`}
                setFieldValue={setFieldValue}
                resetValue={
                  (originalRatecardData &&
                    originalRatecardData.ratecardValues &&
                    originalRatecardData?.ratecardValues.baseRate) ??
                  0
                }
                store={store}
                invoiceStartDate={invoiceStartDate}
                invoiceEndDate={invoiceEndDate}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid>

      {route === null ? (
        <FieldValueEditList
          date_range_values={values.base_rate_date_range_values}
          fieldName="base_rate_date_range_values"
          setFieldValue={setFieldValue}
          isMultiStoreSelected={store.split(",").length > 1}
        />
      ) : null}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container alignItems={"center"} columnSpacing={1}>
          <Grid item xs={5}>
            <Typography>Variable Rate</Typography>
          </Grid>
          <Grid item xs={1}>
            <InfoWithTooltip
              tooltipText={tooltipText2}
              isDisabled={tooltipText2 === "" ? true : false}
              sx={{ color: "orange" }} // Set icon color to orange
            />
          </Grid>
          <Grid container xs={6} alignItems={"center"} columnSpacing={1}>
            <Grid item xs={route === null ? 3 : 6}>
              <FormikTextField
                margin="normal"
                id="variableRate"
                name="variableRate"
                label=""
                helperText={
                  route !== null &&
                  values.variableRate !==
                    originalRatecardData?.ratecardValues.variableRate
                    ? `Original value : ${originalRatecardData?.ratecardValues.variableRate}`
                    : ""
                }
                isDisabled={
                  values.master_date_range &&
                  values.master_date_range.length === 2
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(
                          values.variable_rate_date_range_values
                        )
                      )
                    : false
                }
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                size="small"
                fullWidth
                variant={"outlined"}
                required
              />
            </Grid>
            <Grid item xs={route === null ? 3 : 6}>
              <FormikTextField
                select
                margin="normal"
                id="variableRateType"
                name="variableRateType"
                label="Variable Rate Type"
                size="small"
                helperText={
                  route !== null &&
                  values.variableRateType !==
                    originalRatecardData?.ratecardValues.variableRateType
                    ? `Original value : ${originalRatecardData?.ratecardValues.variableRateType}`
                    : ""
                }
                isDisabled={
                  values.master_date_range &&
                  values.master_date_range.length === 2
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(
                          values.variable_rate_date_range_values
                        )
                      )
                    : false
                }
                fullWidth
                variant={"outlined"}
                required
              >
                {VARIABLE_RATE_TYPES.map((state, index) => (
                  <MenuItem key={index} value={state}>
                    {`Per ${state.replace("_", " ")}`}
                  </MenuItem>
                ))}
              </FormikTextField>
            </Grid>

            {route === null ? (
              <SimpleFieldDatePicker
                text={tooltipText2}
                values={values}
                field={values.variableRate}
                fieldType={values.variableRateType}
                date_range={values.variable_rate_date_range}
                date_range_values={values.variable_rate_date_range_values}
                fieldName={`variableRate`}
                fieldTypeName={`variableRateType`}
                fieldDateRangeName={`variable_rate_date_range`}
                fieldDateRangeValuesName={`variable_rate_date_range_values`}
                setFieldValue={setFieldValue}
                resetValue={
                  (originalRatecardData &&
                    originalRatecardData.ratecardValues &&
                    originalRatecardData.ratecardValues.variableRate) ??
                  0
                }
                store={store}
                invoiceStartDate={invoiceStartDate}
                invoiceEndDate={invoiceEndDate}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid>

      {route === null ? (
        <FieldValueEditList
          date_range_values={values.variable_rate_date_range_values}
          fieldName="variable_rate_date_range_values"
          setFieldValue={setFieldValue}
          isMultiStoreSelected={store.split(",").length > 1}
        />
      ) : null}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container alignItems={"center"} columnSpacing={1}>
          <Grid item xs={5}>
            <Typography>Route Minimum</Typography>
          </Grid>
          <Grid item xs={1}>
            <InfoWithTooltip
              tooltipText={tooltipText3}
              isDisabled={tooltipText3 === "" ? true : false}
              sx={{ color: "orange" }} // Set icon color to orange
            />
          </Grid>
          <Grid container xs={6} alignItems={"center"} columnSpacing={1}>
            <Grid item xs={route === null ? 6 : 12}>
              <FormikTextField
                margin="normal"
                id="routeMinimum"
                name="routeMinimum"
                label=""
                helperText={
                  route !== null &&
                  values.routeMinimum !==
                    originalRatecardData?.ratecardValues.routeMinimum
                    ? `Original value : ${originalRatecardData?.ratecardValues.routeMinimum}`
                    : ""
                }
                isDisabled={
                  values.master_date_range &&
                  values.master_date_range.length === 2
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(
                          values.route_minimum_date_range_values
                        )
                      )
                    : false
                }
                size="small"
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                fullWidth
                variant={"outlined"}
                required
              />
            </Grid>
            {route === null ? (
              <SimpleFieldDatePicker
                text={tooltipText3}
                values={values}
                field={values.routeMinimum}
                date_range={values.route_minimum_date_range}
                date_range_values={values.route_minimum_date_range_values}
                fieldName={`routeMinimum`}
                fieldDateRangeName={`route_minimum_date_range`}
                fieldDateRangeValuesName={`route_minimum_date_range_values`}
                setFieldValue={setFieldValue}
                resetValue={
                  (originalRatecardData &&
                    originalRatecardData.ratecardValues &&
                    originalRatecardData.ratecardValues.routeMinimum) ??
                  0
                }
                store={store}
                invoiceStartDate={invoiceStartDate}
                invoiceEndDate={invoiceEndDate}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid>

      {route === null ? (
        <FieldValueEditList
          date_range_values={values.route_minimum_date_range_values}
          fieldName="route_minimum_date_range_values"
          setFieldValue={setFieldValue}
          isMultiStoreSelected={store.split(",").length > 1}
        />
      ) : null}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container alignItems={"center"} columnSpacing={1}>
          <Grid item xs={5}>
            <Typography>Late Cancellation Charge</Typography>
          </Grid>
          <Grid item xs={1}>
            <InfoWithTooltip
              tooltipText={tooltipText4}
              isDisabled={tooltipText4 === "" ? true : false}
              sx={{ color: "orange" }} // Set icon color to orange
            />
          </Grid>
          <Grid container xs={6} alignItems={"center"} columnSpacing={1}>
            <Grid item xs={route === null ? 3 : 6}>
              <FormikTextField
                margin="normal"
                id="lateCancellationCharge"
                name="lateCancellationCharge"
                label=""
                helperText={
                  route !== null &&
                  values.lateCancellationCharge !==
                    originalRatecardData?.ratecardValues.lateCancellationCharge
                    ? `Original value : ${originalRatecardData?.ratecardValues.lateCancellationCharge}`
                    : ""
                }
                isDisabled={
                  route
                    ? true
                    : values.master_date_range &&
                      values.master_date_range.length === 2
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(
                          values.late_cancellation_date_range_values
                        )
                      )
                    : false
                }
                size="small"
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                fullWidth
                variant={"outlined"}
                required
              />
            </Grid>
            <Grid item xs={route === null ? 3 : 6}>
              <FormikTextField
                select
                margin="normal"
                id="lateCancellationType"
                name="lateCancellationType"
                label="Late Cancellation Type"
                size="small"
                helperText={
                  route !== null &&
                  values.lateCancellationType !==
                    originalRatecardData?.ratecardValues.lateCancellationType
                    ? `Original value : ${originalRatecardData?.ratecardValues.lateCancellationType}`
                    : ""
                }
                isDisabled={
                  // this is disabled when route is selected
                  route
                    ? true
                    : values.master_date_range &&
                      values.master_date_range.length === 2
                    ? isDisabledFieldDueToDateRangeEdits(
                        values.master_date_range[0],
                        values.master_date_range[1],
                        getUsedDateRanges(
                          values.late_cancellation_date_range_values
                        )
                      )
                    : false
                }
                fullWidth
                variant={"outlined"}
                required
              >
                {LATE_CANCELLATION_TYPES.map((type, index) => (
                  <MenuItem key={index} value={type}>
                    {mapSnakeCaseToCapitalCaseWithSpaces(type)}
                  </MenuItem>
                ))}
              </FormikTextField>
            </Grid>

            {route === null ? (
              <SimpleFieldDatePicker
                text={tooltipText4}
                values={values}
                field={values.lateCancellationCharge}
                fieldType={values.lateCancellationType}
                date_range={values.late_cancellation_date_range}
                date_range_values={values.late_cancellation_date_range_values}
                fieldName={`lateCancellationCharge`}
                fieldTypeName={`lateCancellationType`}
                fieldDateRangeName={`late_cancellation_date_range`}
                fieldDateRangeValuesName={`late_cancellation_date_range_values`}
                setFieldValue={setFieldValue}
                resetValue={
                  (originalRatecardData &&
                    originalRatecardData.ratecardValues &&
                    originalRatecardData.ratecardValues
                      .lateCancellationCharge) ??
                  0
                }
                store={store}
                invoiceStartDate={invoiceStartDate}
                invoiceEndDate={invoiceEndDate}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid>

      {route === null ? (
        <FieldValueEditList
          date_range_values={values.late_cancellation_date_range_values}
          fieldName="late_cancellation_date_range_values"
          setFieldValue={setFieldValue}
          isMultiStoreSelected={store.split(",").length > 1}
        />
      ) : null}

      {/* Fuel Surcharge */}
      <CiFuelSurcharge
        values={values}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        invoiceStartDate={invoiceStartDate}
        invoiceEndDate={invoiceEndDate}
        route={route}
        originalRatecardData={originalRatecardData}
        store={store}
        editData={editData}
      />

      <CiCustomFields
        values={values}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        invoiceStartDate={invoiceStartDate}
        invoiceEndDate={invoiceEndDate}
        route={route}
        originalRatecardData={originalRatecardData}
        store={store}
        editData={editData}
      />
      {/* Discount Premium */}
      <CiDiscountPremium
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        invoiceStartDate={invoiceStartDate}
        invoiceEndDate={invoiceEndDate}
        route={route}
        originalRatecardData={originalRatecardData}
        store={store}
        editData={editData}
      />

      {/* Peak Surcharge */}
      <CiPeakSurcharge
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        invoiceStartDate={invoiceStartDate}
        invoiceEndDate={invoiceEndDate}
        route={route}
        originalRatecardData={originalRatecardData}
        editData={editData}
      />
    </Grid>
  );
};

export default EditRateCard;
